import { createContext, ReactNode, useContext, useState } from 'react'

type BreadcrumbContextType = {
  entityName: string
  setEntityName: (name: string) => void
}

const BreadcrumbContext = createContext<BreadcrumbContextType>({
  entityName: '',
  setEntityName: () => {},
})

export function BreadcrumbProvider({ children }: { children: ReactNode }) {
  const [entityName, setEntityName] = useState('')
  return (
    <BreadcrumbContext.Provider value={{ entityName, setEntityName }}>
      {children}
    </BreadcrumbContext.Provider>
  )
}

export const useBreadcrumb = () => useContext(BreadcrumbContext)
